exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".heart-filled___1q0zx {\n  color: #c1281b;\n  margin-top: 2px;\n}\n.heart-empty___VJdDB {\n  margin-top: 2px;\n}\n", "", {"version":3,"sources":["/home/jenkins/agent/workspace/causefundraisernodeweb-ci-release/public/js/components/SetPreferredHeart/SetPreferredHeart.less"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,gBAAgB;CACjB;AACD;EACE,gBAAgB;CACjB","file":"SetPreferredHeart.less","sourcesContent":[".heart-filled {\n  color: #c1281b;\n  margin-top: 2px;\n}\n.heart-empty {\n  margin-top: 2px;\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"heart-filled": "heart-filled___1q0zx",
	"heart-empty": "heart-empty___VJdDB"
};